
export const getGradientCardStyle = (icon, bgSize, startColor, endColor) => ({
    background: "#333333",
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    backgroundImage: `linear-gradient(309deg, ${startColor}, ${endColor}), url(${icon}), linear-gradient(153deg, #ff2424, #b40606 19%, #470000)`,
    backgroundPosition:  '0px 0px, 115% 25%, 0px 0px, 115% 50%, 0px 0px',
    backgroundSize: bgSize,
    backgroundRepeat: 'repeat, repeat-y, repeat',
    backgroundAttachment: 'scroll, scroll, scroll',
    gridColumn: 'span 2',
    gridRow: 'span 1'
});



export const cardStyle = {
    background: "#333333",
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    gridColumn: 'span 2',
    gridRow: 'span 1'
};

export const tokenCardStyle = {
  background: "#333333",
  borderRadius: "20px",
  color: "#ffe896",
  marginBottom: "10px",
  fontFamily: 'Inter, sans-serif',
  //backgroundImage: `linear-gradient(263deg, rgb(75 75 75 / 95%), rgb(59 54 54 / 95%)), linear-gradient(153deg,rgb(0, 0, 0), rgb(0, 0, 0) 19%, rgb(0, 0, 0))`,
  backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
  backgroundSize: 'auto, auto 135%, auto',
  backgroundRepeat: 'repeat, repeat-y, repeat',
  backgroundAttachment: 'scroll, scroll, scroll',
  gridColumn: 'span 3',
  gridRow: 'span 1',
  padding: '10px'
};


export const cardStyleSmartRewards = {
    background: "#333333",
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: '20px',
    paddingBottom: '20px',
    gridColumn: "span 3",
    gridRow: "span 1",
}

export const bannerStyle = {
    background: "#fff",
    borderRadius: "20px",
    color: "#333333",
    marginBottom: "10px",
    fontFamily: 'Inter, sans-serif',
    gridColumn: 'span 4',
    gridRow: 'span 4'
};

export const cardHeaderStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    color: 'rgba(255, 255, 255, .7)',
};

export const cardHeaderInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#333333',
};

export const cardOutlineStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 2",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };

  export const walletCardOutlineStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 2",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };

  export const cardSmartRewardOutlineStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 4",
    gridRow: "span 4",
    background: "none", // Set the background to none or transparent
  };

  export const cardOutlineExtendedStyle = {
    border: "1px solid #FFFFFF", // Add border instead of background
    borderRadius: "20px",
    color: "#FFFFFF",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 3",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };
  
  export const cardOutlineHeaderStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "rgba(255, 255, 255, .9)", // Slightly increase opacity for better visibility
  };

  export const infoOutlineStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "39px",
    color: "rgba(255, 255, 255, .9)", // Slightly increase opacity for better visibility
  };
  
  export const miniCardHeaderOutlineStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '14px',
    marginTop: '10px',
    color: 'rgba(255, 255, 255, .7)',
};

export const miniInfoOutlineStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: 'rgba(255, 255, 255, .7)',
};

export const cardOutlineInvertStyle = {
    border: "1px solid rgb(51, 51, 51)", // Add border instead of background
    borderRadius: "20px",
    color: "rgb(51, 51, 51)",
    marginBottom: "10px",
    fontFamily: "Inter, sans-serif",
    gridColumn: "span 3",
    gridRow: "span 1",
    background: "none", // Set the background to none or transparent
  };
  
  export const cardOutlineInvertHeaderStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "22px",
    color: "rgb(51, 51, 51)", // Slightly increase opacity for better visibility
  };

  export const infoOutlineInvertStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "39px",
    color: "rgb(51, 51, 51)", // Slightly increase opacity for better visibility
  };

  export const refuelOutlineInvertStyle = {
    fontFamily: "Inter, sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "22px",
    lineHeight: "39px",
    color: "white", // Slightly increase opacity for better visibility
  };
  
  export const miniCardHeaderOutlineInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '14px',
    marginTop: '10px',
    color: 'rgb(51, 51, 51, .7)',
};

export const miniInfoOutlineInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: 'rgb(51, 51, 51, .7)',
};


export const miniCardHeaderStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '14px',
    marginTop: '10px',
    color: 'rgba(255, 255, 255, .7)',
};

export const miniCardHeaderInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 200,
    fontSize: '14px',
    marginTop: '10px',
    color: '#333333',
};


export const refuelHeaderStyle = {
  fontFamily: 'Inter, sans-serif',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  marginTop: '10px',
  color: '#ffffff',
      marginBottom: '2px',
};




export const bannerHeaderStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '22px',
    color: '#333333',
};

export const infoStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '39px',
    color: '#FFFFFF',
};


export const miniInfoStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: '#FFFFFF',
};

export const miniInfoInvertStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '18px',
    color: '#333333',
};

export const refuelInfoInvertStyle = {
  fontFamily: 'Inter, sans-serif',
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '18px',
  color: '#ffe8bf',
};



export const bannerInfoStyle = {
    fontFamily: 'Inter, sans-serif',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '22px',
    lineHeight: '39px',
    color: '#333333',
};

export const imgGradientCardStyle = {

        background: "#333333",
        borderRadius: "20px",
        color: "#FFFFFF",
        marginBottom: "10px",
        fontFamily: 'Inter, sans-serif',
        backgroundImage: `linear-gradient(309deg, rgb(255 161 135 / 94%), rgb(176 14 146 / 86%)), linear-gradient(153deg, rgb(255, 36, 36), rgb(180, 6, 6) 19%, rgb(71, 0, 0))`,
        backgroundPosition: '0px 0px, 115% 50%, 0px 0px',
        backgroundSize: 'auto, auto 135%, auto',
        backgroundRepeat: 'repeat, repeat-y, repeat',
        backgroundAttachment: 'scroll, scroll, scroll',
        gridColumn: 'span 1',
        gridRow: 'span 1'

};

